<template><ArticlePage page="antiban" :content="content" /></template>
<script>
import ArticlePage from '@/components/ArticlePage.vue';
import content from '@/documents/content/antiban.js';
export default { name: 'AntiBan', components: { ArticlePage }, data: () => ({ content }) };
</script>
